<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="確認"
  >
    <template v-slot:body="{ ok, cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row class="pb-3">
              <strong>
                {{ confirmMessage }}
              </strong>
            </v-row>

            <div class="my-3">
              <!-- 基本設定 -->
              <v-row>
                <v-col>
                  <h3>基本設定</h3>
                </v-col>
              </v-row>
              <!--サービスキー(Act)-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="サービスキー(Act)"
                    :value="
                      saseGatewayPaloAltoDetail.saseGatewayVnConnectAct
                        .serviceKey
                    "
                  />
                </v-col>
              </v-row>
              <!--サービスキー(Sby)-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="サービスキー(Sby)"
                    :value="
                      saseGatewayPaloAltoDetail.saseGatewayVnConnectSby
                        .serviceKey
                    "
                  />
                </v-col>
              </v-row>
              <!--ロケーション-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="ロケーション"
                    :value="
                      $filter.enumTo(
                        saseGatewayPaloAltoDetail.saseGatewayVnConnectCommon
                          .location,
                        'location'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--接続先仮想ネットワーク（VPN/VN）名-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="接続先仮想ネットワーク(VPN/VN)名"
                    :value="
                      saseGatewayPaloAltoDetail.saseGatewayVnConnectCommon.vpnVnCode.startsWith(
                        'B'
                      )
                        ? saseGatewayPaloAltoDetail.saseGatewayVnConnectCommon
                            .vpnVnCode
                        : saseGatewayPaloAltoDetail.saseGatewayVnConnectCommon
                            .vnName +
                          ':' +
                          saseGatewayPaloAltoDetail.saseGatewayVnConnectCommon
                            .vpnVnCode +
                          '(L3)'
                    "
                  />
                </v-col>
              </v-row>

              <!-- VNコネクト設定 -->
              <v-row class="mt-2">
                <v-col>
                  <h3>VNコネクト設定</h3>
                </v-col>
              </v-row>
              <!--品目-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="品目"
                    :value="
                      saseGatewayPaloAltoDetail.saseGatewayVnConnectCommon
                        .bandwidthType +
                      '(' +
                      $filter.bandwidthTo(
                        saseGatewayPaloAltoDetail.saseGatewayVnConnectCommon
                          .bandwidth
                      ) +
                      ')'
                    "
                  />
                </v-col>
              </v-row>
              <!--VNコネクト名（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="VNコネクト名(Act)"
                    :value="
                      saseGatewayPaloAltoDetail.saseGatewayVnConnectAct
                        .vnConnectName
                    "
                  />
                </v-col>
              </v-row>
              <!--VNコネクト名（Sby）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="VNコネクト名(Sby)"
                    :value="
                      saseGatewayPaloAltoDetail.saseGatewayVnConnectSby
                        .vnConnectName
                    "
                  />
                </v-col>
              </v-row>

              <!-- ルーティング情報（共通） -->
              <v-row class="mt-2">
                <v-col>
                  <h3>ルーティング情報(共通)</h3>
                </v-col>
              </v-row>
              <!--ルーティング種別-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="ルーティング種別"
                    :value="
                      saseGatewayPaloAltoDetail.saseGatewayVnConnectCommon
                        .routingType
                    "
                  />
                </v-col>
              </v-row>
              <!--AS番号-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="AS番号"
                    :value="
                      saseGatewayPaloAltoDetail.saseGatewayVnConnectCommon
                        .asNumber
                    "
                  />
                </v-col>
              </v-row>
              <!--Maximum Prefix-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="Maximum Prefix"
                    :value="
                      saseGatewayPaloAltoDetail.saseGatewayVnConnectCommon
                        .maximumPrefix
                    "
                  />
                </v-col>
              </v-row>

              <!-- ルーティング情報（Act） -->
              <v-row class="mt-2">
                <v-col>
                  <h3>ルーティング情報(Act)</h3>
                </v-col>
              </v-row>
              <!--WANアドレス（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="WANアドレス"
                    :value="
                      $filter.emptyTo(
                        saseGatewayPaloAltoDetail.saseGatewayVnConnectAct
                          .wanAddress,
                        '-'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--ピアIPアドレス（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="ピアIPアドレス"
                    :value="
                      $filter.emptyTo(
                        saseGatewayPaloAltoDetail.saseGatewayVnConnectAct
                          .peerIpAddress,
                        '-'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--Local Preference（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="Local Preference"
                    :value="
                      $filter.enumTo(
                        saseGatewayPaloAltoDetail.saseGatewayVnConnectAct
                          .localPreference,
                        'localPreference'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--MED（Act）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="MED"
                    :value="
                      $filter.enumTo(
                        saseGatewayPaloAltoDetail.saseGatewayVnConnectAct.med,
                        'med'
                      )
                    "
                  />
                </v-col>
              </v-row>

              <!-- ルーティング情報（Sby） -->
              <v-row class="mt-2">
                <v-col>
                  <h3>ルーティング情報(Sby)</h3>
                </v-col>
              </v-row>

              <!--WANアドレス（Sby）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="WANアドレス"
                    :value="
                      $filter.emptyTo(
                        saseGatewayPaloAltoDetail.saseGatewayVnConnectSby
                          .wanAddress,
                        '-'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--ピアIPアドレス（Sby）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="ピアIPアドレス"
                    :value="
                      $filter.emptyTo(
                        saseGatewayPaloAltoDetail.saseGatewayVnConnectSby
                          .peerIpAddress,
                        '-'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--Local Preference（Sby）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="Local Preference"
                    :value="
                      $filter.enumTo(
                        saseGatewayPaloAltoDetail.saseGatewayVnConnectSby
                          .localPreference,
                        'localPreference'
                      )
                    "
                  />
                </v-col>
              </v-row>
              <!--MED（Sby）-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="MED"
                    :value="
                      $filter.enumTo(
                        saseGatewayPaloAltoDetail.saseGatewayVnConnectSby.med,
                        'med'
                      )
                    "
                  />
                </v-col>
              </v-row>

              <!-- カスタム経路集約情報 -->
              <v-row class="mt-2">
                <v-col>
                  <h3>カスタム経路集約情報</h3>
                </v-col>
              </v-row>
              <!--経路集約-->
              <v-row>
                <v-col>
                  <app-label-group
                    label="経路集約"
                    :value="
                      saseGatewayPaloAltoDetail.saseGatewayVnConnectCommon
                        .routeAggregation
                    "
                  />
                </v-col>
              </v-row>

              <!--経路集約アドレス-->
              <v-row
                v-if="
                  saseGatewayPaloAltoDetail.saseGatewayVnConnectCommon
                    .routeAggregation === 'CUSTOM'
                "
              >
                <v-col>
                  <app-label-group label="経路集約アドレス">
                    <template #value>
                      <div class="d-flex flex-wrap">
                        <span
                          class="ml-3"
                          v-for="(
                            ip, index
                          ) in sortedRouteAggregationAddressList"
                          :key="index"
                        >
                          {{ ip }}
                        </span>
                      </div>
                    </template>
                  </app-label-group>
                </v-col>
              </v-row>

              <!-- 保守連絡先情報 -->
              <v-row class="mt-2">
                <v-col>
                  <h3>保守連絡先情報</h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <app-label-group
                    label="会社名"
                    :value="saseGatewayPaloAltoDetail.maintenance.company"
                  />
                </v-col>
                <v-col cols="4">
                  <app-label-group
                    label="部署名"
                    :value="saseGatewayPaloAltoDetail.maintenance.department"
                  />
                </v-col>
                <v-col cols="4">
                  <app-label-group
                    label="担当者名"
                    :value="saseGatewayPaloAltoDetail.maintenance.name"
                  />
                </v-col>
                <v-col cols="4">
                  <app-label-group
                    label="電話番号"
                    :value="saseGatewayPaloAltoDetail.maintenance.phone"
                  />
                </v-col>
                <v-col cols="4">
                  <app-label-group
                    label="メールアドレス"
                    :value="saseGatewayPaloAltoDetail.maintenance.email"
                  />
                </v-col>
              </v-row>

              <!--備考-->
              <v-row class="mt-4">
                <v-col>
                  <app-label-group
                    label="備考"
                    :value="
                      $filter.emptyTo(
                        saseGatewayPaloAltoDetail.saseGatewayVnConnectCommon
                          .description,
                        '-'
                      )
                    "
                  />
                </v-col>
              </v-row>

              <template v-if="displayType === 'A'">
                <!-- お知らせ -->
                <div class="font-weight-bold mt-4">次のステップ</div>
                <v-sheet border rounded class="pa-2">
                  Palo Alto の設定を続けて行う場合は、 登録完了後に追加された
                  VNコネクト番号を押下し、 表示される「Palo
                  Alto管理コンソール」を開いてください。
                </v-sheet>

                <div class="font-weight-bold mt-5">
                  VNコネクトを追加する前に、以下確認をしてください。
                </div>
                <v-sheet border rounded class="pa-2">
                  <v-checkbox
                    v-model="checkedPriceChange"
                    label="追加（料金変更）に関わる操作を実行します。"
                    hide-details
                  />
                </v-sheet>
              </template>

              <template v-if="displayType === 'M'">
                <div class="font-weight-bold mt-5">
                  VNコネクトを変更する前に、以下確認をしてください。
                </div>
                <v-sheet border rounded class="pa-2">
                  <v-checkbox
                    v-model="checkedPriceChange"
                    label="VNコネクトの品目変更に伴いご請求料金が変更となることを承知していますか。"
                    hide-details
                  />
                </v-sheet>
              </template>
            </div>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn
              @click="ok"
              variant="flat"
              color="primary"
              :disabled="!checkedPriceChange"
              >はい</v-btn
            >
            <v-btn @click="cancel" variant="outlined" color="primary"
              >いいえ</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { SaseGatewayPaloAltoDetailEntity } from "@/apis/SaseGatewayApi";

export default defineComponent({
  name: "SaseGatewayPaloAltoVnConnectionConfirm",
  props: {
    saseGatewayPaloAltoDetail: {
      type: Object as PropType<SaseGatewayPaloAltoDetailEntity>,
      required: true,
    },
    /** 画面表示モード:
     * A - 追加確認
     * M - 編集確認
     */
    displayType: {
      type: String as PropType<"A" | "M">,
      required: true,
    },
  },
  computed: {
    confirmMessage(): string {
      switch (this.displayType) {
        case "A":
          return "こちらの内容でSASEゲートウェイPalo Alto向けVN回線を追加します。よろしいですか？";
        case "M":
          return "こちらの内容でSASEゲートウェイPalo Alto向けVN回線を変更します。よろしいですか？";
        default:
          throw new Error("wrong displayType!");
      }
    },
    /**
     * 経路集約アドレスリストを数値順(IPアドレス順)で昇順ソート
     * @returns ソート済みの経路集約アドレスリスト
     */
    sortedRouteAggregationAddressList(): string[] {
      const list =
        this.saseGatewayPaloAltoDetail?.saseGatewayVnConnectCommon
          ?.routeAggregationAddressList;
      return Array.isArray(list) ? list : [];
    },
  },
  data() {
    return {
      checkedPriceChange: false,
    };
  },
});
</script>

<style lang="scss" scoped>
:deep(.v-checkbox .v-selection-control) {
  min-height: auto;
}
</style>
